import { faApple, faSpotify } from "@fortawesome/free-brands-svg-icons";
import { faCircle, faX, faXmark } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
// import FEATURE_IMG from "../assets/images/feature.png";
import useGlobalService from "../features/Global/useGlobalService";
import { useGlobalSelector } from "../features/useSelector";
import { motion } from "framer-motion";
import { fade, fadeInOut } from "../util";
import { useEffect, useState } from "react";
import MyAsset from "../asset_strings";
import $ from "jquery";
import { googleSheetUrl_form, googleSheetUrl_notacult } from "../constants";
import { Success } from "../helpers/google/handleGoogleSheet";
import InputField from "./Form/InputField";
import useGoogleSheet from "../helpers/google/useGoogleSheet";
import { Formik, Form } from "formik";
import Button from "./Form/Button";
import Swal from "sweetalert2";

export default function FormPopup() {
  const { presavePopupOpen: open } = useGlobalSelector();
  const [initialOpen, setInitialOpen] = useState(false);
  const { setPresavePopupOpen } = useGlobalService();
  const { googleSheet } = useGoogleSheet();

  useEffect(() => {
    setTimeout(() => {
      setInitialOpen(open);
    }, 700);
  }, [open]);

  return (
    <div
      className={`flex left-0 fixed w-full h-screen px-[--default-space] ${
        initialOpen ? "top-0 opacity-100" : "-top-[120%] opacity-0"
      }`}
      style={{ zIndex: 123123123123 }}
    >
      <motion.div
        initial="visible"
        animate={open ? "visible" : "hidden"}
        variants={fade}
        className={`bg-black border-[.2vw] border-brand relative overflow-hidden m-auto shadow-lg gap-[--space-between-items]  p-[2vw] flex flex-col justify-center items-center w-full md:w-[35%]`}
      >
        <div
          className="absolute top-0 md:top-2 right-1 md:right-3 text-xl md:text-3xl cursor-pointer font-wingdings2"
          onClick={() => setPresavePopupOpen(false)}
        >
          Ò
        </div>
        <div>
          <h4 className="section-heading text-center text-brand px-8 md:px-0">
            Keep up with the latest from SAINt JHN
          </h4>
        </div>
        <Formik
          initialValues={{ email: "" }}
          onSubmit={async (values, { resetForm }) => {
            try {
              const submitted = await googleSheet.uploadForm(
                {
                  ...values,
                },
                googleSheetUrl_form,
              );

              setTimeout(() => {
                Swal.fire({ icon: "success", text: "success" });
              }, 300);

              resetForm();
            } catch (error) {
              setTimeout(() => {
                Swal.fire({ icon: "error", titleText: "Error!" });
              }, 300);
            }
          }}
        >
          {({ isSubmitting }) => (
            <Form className="flex flex-col justify-center items-center w-full mx-auto gap-[--space-btw-items] mt-[--space-btw-sections]">
              <InputField
                type="text"
                name="email"
                // label="Email"
                placeholder="EMAIL"
              />
              <Button
                isSubmitting={isSubmitting}
                type="submit"
                className="btn-primary w-full flex text-center justify-center items-center"
              >
                <span>SUBMIT</span>
              </Button>
            </Form>
          )}
        </Formik>
      </motion.div>
    </div>
  );
}
